const filterNews = (elements, slug) => { 
    const elementsToFilter = document.querySelectorAll(elements)
    elementsToFilter.forEach(el => { 
        el.dataset.category.indexOf(slug) > -1 ? el.style.display = '' : el.style.display = 'none'
    })
}